import React from "react";
import sCurveLogo from "static/images/landing-page/sCurveLogo.svg";
import LandingPageHeading from "./LandingPageHeading";

export const Content = ({
    heading,
    detail,
    image,
  }: {
    heading: string;
    detail: React.ReactNode;
    image?: {
      src: string;
      altText: string;
    };
  }) => {
    return (
      <div className="flex">
        <div className="w-full xxl:w-2/3">
          <LandingPageHeading text={heading} classNames="mb-8" />
          <div className="font-medium text-base lg:text-lg leading-7 lg:leading-37px max-w-190">
            {detail}
          </div>
        </div>
        <div className="hidden xxl:flex w-1/3 justify-center">
          {image && <img src={image.src} alt={image.altText} />}
        </div>
      </div>
    );
  };

export default function AboutTimePhasing() {
  return (
    <div>
      <div className="mb-14">
        <Content
          heading="What is timePhasing?"
          detail={
            <>
              <p className="mb-4">
                timePhasing is a cloud service that converts project schedules and budgets into time‑phased datasets ready for reporting and analysis.
              </p>
              <p className="mb-4 font-semibold">
                Built for Project Controls, BI & Analytics teams, and developers integrating project data pipelines.
              </p>
              <div className="mb-4">
                <p><strong>Input:</strong> Primavera P6, MS Project, Excel or JSON project data.</p>
                <p><strong>Output:</strong> Time‑phased values, S‑curve ready datasets, JSON/CSV for BI tools.</p>
              </div>
              <p className="mb-4 italic">
                No spreadsheets. No manual phasing. Fully automated, repeatable results.
              </p>
              <p className="mb-4 text-primaryRed font-semibold">
                Free API key available for testing. Usage‑based service.
              </p>
              <p className="text-sm bg-gray-100 p-3 rounded-lg">
                <strong>Example:</strong> Primavera schedule → time‑phased values → Power BI S‑curve in minutes.
              </p>
            </>
          }
          image={{
            src: sCurveLogo,
            altText: "S-curve generation from time-phasing API",
          }}
        />
      </div>
      <div className="mb-14 border-b border-promGray2"></div>
      <Content
        heading="How does it work?"
        detail={
          <p>
            timePhasing is a time-phasing API that integrates your BI platform with
            your project scheduling software. It enables S-curve generation and project schedule phasing from existing data in
            your project schedules. It works as follows:
          </p>
        }
      />
    </div>
  );
}
